
import * as actions from '@/AppRedux/actions/auth/authType';

const initialState: actions.AuthState = {
  loading: false,
  user: null,
  propCode: null,
  token: null,
  error: null,
};

export default function authReducer(
  state: actions.AuthState = initialState,
  action: actions.AuthAction
): actions.AuthState {
  switch (action.type) {
    case actions.LOGIN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actions.LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload.user,
        token: action.payload.token,
        propCode: action.payload.propCode,
        error: null,
      };
    case actions.LOGIN_FAILURE:
      return {
        ...state,
        loading: false,
        user: null,
        token: null,
        propCode: null,
        error: action.payload,
      };
    case actions.LOGOUT:
      return {
        ...state,
        user: null,
        token: null,
        error: null,
        propCode: null,
      };
    default:
      return state;
  }
}
